/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect, useRef, useState } from "react";
import ReactModal from 'react-modal'
import styled from "styled-components";
import useClientMediaQuery from 'hooks/useMediaQuery'
import KBPopup from 'img/KB-PopUp.png'


const Close = styled.div`
  position: relative;
  right: -32rem;
  top: 11rem;
  z-index: 999999;
  cursor: pointer;

  @media (max-width: 991px) {
    right: -20rem;
    top: 7rem;
  }
`

const StyledDiv = styled.div`
  position: relative;
  z-index: 9999;
`

const Image = styled.img`
  object-fit: cover;
  width: 550px;
  height: auto;

  @media (max-width: 991px) {
    width: 350px;
  }
`

export default function SlideIn() {
  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useClientMediaQuery('(min-width: 992px)')
  const ref = useRef(null)

  function closeModal() {
    sessionStorage.setItem("hide", "true");
    setIsOpen(false);
  }

  useEffect(() => {
    const { documentElement: html } = document

    setTimeout(() => {
      {
        !sessionStorage.getItem('hide') && (
          setIsOpen(true)
        )
      }
    }, 3000)

    if (isOpen) {
      html.classList.add('overflow-hidden')
    } else {
      html.classList.remove('overflow-hidden')
    }
  }, [isOpen])

  const customStyles = {
    content: {
      position: 'fixed',
      top: 'auto',
      width: isDesktop ? '570px' : '370px',
      height: isDesktop ? '402px' : '265px',
      border: 0,
      bottom: 0,
      left: 'auto',
      right: 0,
      background: 'transparent',
      zIndex: '9999',
      overflow: 'hidden',
    }
  }

  return (
    <ReactModal isOpen={isOpen} style={customStyles}>
      <StyledDiv ref={ref}>
        <Close role="button" onClick={() => closeModal()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#000" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6L6.4 19Z" /></svg>
        </Close>
        <a href="/vacatures/"><Image src={KBPopup} alt="" /></a>
      </StyledDiv>
    </ReactModal >
  )
}
